<lib-ikp-info-card-title
  id="title"
  [infoCardType]="infoCardType()"
  [title]="title()"
  [truncateTitle]="truncateTitle()"
  [subtitle]="subtitle()"
  [iconPath]="iconPath()"
  [actionText]="actionText()"
  [actionColor]="actionColor()"
  [actionIcon]="actionIcon()"
  [(isCollapsed)]="isCollapsed"
  [isCheckbox]="isCheckbox()"
  [isChecked]="isChecked()"
  (actionClicked)="onActionClicked()"
  [index]="index()"
  [attr.data-test]="index() ? 'info-card-idx-' + index() : 'info-card'"
/>
@if (!isCollapsed()) {
  <div class="section-content-container">
    <ng-content />
  </div>
}
